import type { ProductInventoryItem } from '../interface';

/** รายการ general ใน products[] ของ GET inventory */
export type GeneralStockItem = ProductInventoryItem & { type: 'general' };

/** แปลงรายการ general จาก inventory → payload ฟอร์ม CRUD */
export type GeneralStockFormEdit = {
  id: string;
  name?: string;
  description?: string;
  images?: string[];
  image_urls?: string[];
  quantity: number;
  holding_quantity?: number;
  stock_balance?: number;
  remark?: string;
  safe_stock_quantity: number;
  is_safe_stock_enabled: boolean;
  is_active: boolean;
};

export function inventoryGeneralToFormStock(
  item: ProductInventoryItem
): GeneralStockFormEdit {
  return {
    id: item.id,
    name: item.name,
    description: item.description,
    images: item.main_images,
    image_urls: item.main_images_url,
    quantity: item.stock?.stock_quantity ?? 0,
    holding_quantity: item.stock?.holding_quantity ?? 0,
    stock_balance: item.stock?.stock_balance ?? 0,
    remark: item.remark,
    safe_stock_quantity: item.stock?.safe_stock_quantity ?? 0,
    is_safe_stock_enabled: item.stock?.is_safe_stock_enabled ?? false,
    is_active: item.is_active !== false,
  };
}

export interface CreateGeneralStockInput {
  name?: string;
  description?: string;
  images?: string[];
  quantity?: number;
  remark?: string;
  safe_stock_quantity?: number;
  is_safe_stock_enabled?: boolean;
  is_active?: boolean;
}

export interface UpdateGeneralStockInput {
  id: string;
  name?: string;
  description?: string;
  images?: string[];
  quantity?: number;
  remark?: string;
  safe_stock_quantity?: number;
  is_safe_stock_enabled?: boolean;
  is_active?: boolean;
}

export interface CreateGeneralStockResponse {
  status: string;
  data: Record<string, unknown>;
}

export interface GetGeneralStockResponse {
  status: string;
  data: Record<string, unknown>;
}

export interface UpdateGeneralStockResponse {
  status: string;
  data: Record<string, unknown>;
}

export interface DeleteGeneralStockResponse {
  status: string;
  data: { success: boolean };
}

export interface ListGeneralStockTransactionsInput {
  stock_id: string;
  page?: number;
  limit?: number;
}

export interface GeneralStockTransactionRow {
  id: string;
  direction: 'in' | 'out';
  quantity: number;
  remark: string | null;
  type: string;
  product_stock_id: string | null;
  create_date: string;
}

export interface ListGeneralStockTransactionsResponse {
  status: string;
  data: {
    rows: GeneralStockTransactionRow[];
    total: number;
  };
}

export interface AdjustGeneralStockInput {
  /** product_stock.id ของ type=GENERAL */
  stock_id: string;
  /** "in" = เพิ่มเข้าคลัง | "out" = นำออก */
  direction: 'in' | 'out';
  /** จำนวน (บวกเสมอ ≥ 1) */
  quantity: number;
  remark?: string;
}

export interface AdjustGeneralStockResponse {
  status: string;
  data: {
    stock: {
      id: string;
      quantity: number;
      holding_quantity: number;
    };
    inbound?: { id: string; quantity: number };
    outbound?: { id: string; quantity: number };
  };
}
